// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"31":"89a996f1a2c6d110","721":"eec87a1cdbfa2322","887":"878b5facf2ddeaf2"}[chunkId] + ".js";
};